/**
 * The Transmit gate (mission 6 T012; FR-016, FR-018; TX.4, X.10, GEN.6;
 * DM-01M3BGTHX2A3ERXRZPEMVE5EEM).
 *
 * Read from `state`, `path`, `deliverable` and `error_count` only. Absent for
 * a run that is not ready (GEN.4: there is no file to transmit yet, and the
 * backend reports `deliverable` true before generation; mission 6 review
 * follow-up 22, A-5), for Path B (X.10: Trellis never transmits a file it did
 * not generate) and for a run that is not deliverable (GEN.6); otherwise
 * ready, or needing the ERROR acknowledgment (TX.4). WP03's `TransmitControl` renders it as a secondary
 * button in both states (DM-01M3C8MP7AV3AWFNA6R365X21T).
 */
import type { Run } from './api/runs'

export type TransmitGateInput = Pick<Run, 'state' | 'path' | 'deliverable' | 'error_count'>

export type TransmitGate = { kind: 'absent' } | { kind: 'ready' } | { kind: 'acknowledge'; errors: number }

export function transmitGate(run: TransmitGateInput): TransmitGate {
  if (run.state !== 'ready' || run.path !== 'generate' || !run.deliverable) return { kind: 'absent' }
  const errors = run.error_count ?? 0
  return errors > 0 ? { kind: 'acknowledge', errors } : { kind: 'ready' }
}
